import React from "react";
import { useTranslation } from "react-i18next";
import roundButtonStyles from "features/shared/components/buttons/roundbutton.module.scss";

interface Props {}

const Ets2AffidavitSimplifiedHeader = (props: Props) => {
  const tLabels = useTranslation("ets2\\ets2").t;

  return (
    <div className="d-none d-sm-block px-3 mb-2 text-muted font-weight-bold">
      <div className="row no-gutters align-items-end">
        <div className="col-sm">
          <div className="row no-gutters align-items-end">
            <div className="col-sm-3 pr-sm-2">
              {tLabels("ets2AffidavitSimplifiedHeader.affidavitNumber")}
              <span className="d-sm-none d-lg-inline"> {tLabels("ets2AffidavitSimplifiedHeader.affidavitWord")}</span>
            </div>
            <div className="col-sm-2 pr-sm-2 text-center">
              {tLabels("ets2AffidavitSimplifiedHeader.year")}
              <span className="d-sm-none d-lg-inline"> {tLabels("ets2AffidavitSimplifiedHeader.affidavitWord")}</span>
            </div>
            <div className="col-sm-4 pr-sm-2 text-center">
              {tLabels("ets2AffidavitSimplifiedHeader.createdDate")}
            </div>
            <div className="col-sm-3">
              {tLabels("ets2AffidavitSimplifiedHeader.status")}
            </div>
          </div>
        </div>

        <div className="col-sm-auto pl-sm-3">
          <div className="d-flex">
            <div className={`btn btn-sm ${roundButtonStyles.roundBtn} invisible`} />
            <div className={`btn btn-sm ${roundButtonStyles.roundBtn} ml-2 invisible`} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Ets2AffidavitSimplifiedHeader;
